class AppConfig {

  encryptionKey = "";

  setEncryptionKey(key) {
    this.encryptionKey = key;
  }

  getEncryptionKey() {
    return this.encryptionKey;
  }

}

export const appConfig = new AppConfig();